/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import { Logger, Auth } from 'aws-amplify';
import { CSVLink } from 'react-csv';
import {
  DropDown, SearchInput, Pulse, PrimaryButton,
} from 'wf-react-component-library';
import ItemDetailsModal from '../ItemDetailsModal';
import AddItemModal from '../AddItemModal';
import EditItemModal from '../EditItemModal';
import currencyFormatter from '../../utilities/currency-formatter';
import MaintainCustomers from '../MaintainCustomers';
import UploadCSVModal from '../UploadCSVModal';
import DeleteConfirmationModal from '../DeleteConfirmationModal';
import AddPremium from '../AddPremium';
import {
  getVendors,
  getCategories,
  getLocations,
  getCountryOfOrigins,
  getCustomers,
} from '../../services/api/P3ApiService';
import { keyValueMapper } from '../../utilities/key-value-util';
import { getItemsByVendorCode } from '../../services/api/VIRSApiService';
import { deleteVendorItem } from '../../services/api/DeleteApiService';
import { getVendorItemCustomersByVendorCode } from '../../api/p3/VendorItemCustomerApi';
import appConfig from '../../configuration/AppConfig';

import downarrow from '../../icons/down-arrow.svg';
import uparrow from '../../icons/up-arrow.svg';
import './VendorItemRelationshipMaintenance.scss';

const logger = new Logger('VendorItemRelationshipMaintenance.js');

class VendorItemRelationshipMaintenance extends Component {
  state = {
    categories: {},
    categoryDetails: [],
    locations: {},
    locationDetails: [],
    countryOfOrigins: {},
    countryOfOriginDetails: [],
    isLoadingVendors: true,
    isLoadingItemsForVendor: false,
    vendors: {},
    vendorDetails: [],
    customers: {},
    customerDetails: [],
    actions: appConfig.PREMIUM_FEATURE_ACTIVE === "true" ? {
      1: 'Add Item(s)',
      2: 'Edit Item(s)',
      3: 'Remove Item(s)',
      4: 'Maintain Customers',
      5: 'Manage Premium'
    }
    : {
      1: 'Add Item(s)',
      2: 'Edit Item(s)',
      3: 'Remove Item(s)',
      4: 'Maintain Customers'
    },
    items: [],
    checkboxOptions: {
      1: '',
    },
    selectAllChecked: false,
    selectedItems: [],
    showItemTable: false,
    showItemDetails: false,
    selectedItem: {},
    searchItems: [],
    showAddItemModal: false,
    selectedAction: '',
    selectedVendor: null,
    showEditItemModal: false,
    showCustomersModal: false,
    sortBy: 'id',
    sortDesc: true,
    actionErrorMsg: '',
    showUploadModal: false,
    showDeleteConfirmation: false,
    isLoadingCustomers: false,
    showManagePremium: false
  };

  componentDidMount = () => {

    logger.debug('loading categories...');
    getCategories()
      .then((categoryDetails) => {
        logger.debug('categoryDetails loaded ...', categoryDetails);
        const categories = keyValueMapper(categoryDetails, 'name', 'name');
        logger.debug('categories mapped ...', categories);
        this.setState({ categories, categoryDetails });
      })
      .catch((err) => logger.error('Unable to load categories', err));

    logger.debug('loading locations...');
    getLocations().then((locationDetails) => {
      logger.debug('locationDetail loaded', locationDetails);
      const locations = keyValueMapper(locationDetails, 'code', 'code');
      logger.debug('locations mapped ...', locations);
      this.setState({ locationDetails, locations });
    });

    logger.debug('loading country of origins...');
    getCountryOfOrigins().then((countryOfOriginDetails) => {
      logger.debug('country of origins loaded', countryOfOriginDetails);
      const countryOfOrigins = keyValueMapper(
        countryOfOriginDetails,
        'name',
        'name'
      );
      logger.debug('country of origins mapped ...', countryOfOrigins);
      this.setState({ countryOfOriginDetails, countryOfOrigins });
    });

    getCustomers().then((customerDetails) => {
      logger.debug('customers loaded', customerDetails);
      const customers = keyValueMapper(
        customerDetails,
        'description',
        'description'
      );
      logger.debug('customers mapped', customers);
      this.setState({ customers, customerDetails });
    });

    logger.debug('loading vendors...');
    getVendors()
      .then((vendorDetails) => {
        logger.debug('vendors loaded ...', vendorDetails);
        const vendors = keyValueMapper(vendorDetails, 'code', 'description');
        logger.debug('vendors mapped ...', vendors);
        this.setState({ vendors, vendorDetails, isLoadingVendors: false });
      })
      .catch((err) => logger.error('Unable to load vendors', err));

    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.setState({ currentUser: user.signInUserSession.idToken.payload.email });
      })
      .catch((error) => {
        logger.error('User is not authenticated ', error);
        throw error;
      });
  };

  handleVendorChange = async (e) => {
    const selectedVendor = e.target.value;
    
    this.setState({ isLoadingItemsForVendor: true, isLoadingCustomers: true });
    
    getItemsByVendorCode(selectedVendor)
      .then((items) => {
        this.setState({
          selectedAction: '',
          showItemTable: true,
          selectedVendor,
          items,
          searchItems: items,
          isLoadingItemsForVendor: false,
          selectedItems: [],
          selectAllChecked: false,
          actionErrorMsg: '',
        });
      })
      .catch((err) => {
        logger.error(`Unable to get items by vendor code: ${selectedVendor}`, err);
        this.setState({ isLoadingItemsForVendor: false, searchItems: [], items: [] });
      });

      getVendorItemCustomersByVendorCode(selectedVendor).then(resp => {
        this.setState({ vendorItemCustomers: resp, isLoadingCustomers: false });
      })
      .catch((err) => {
        this.setState({ vendorItemCustomers: [], isLoadingCustomers: false });
      });    
  };

  handleActionChange = (e) => {
    const selectedAction = e.target.value;
    const actionItem = selectedAction === '' ? 0 : parseInt(selectedAction, 10);
    switch (actionItem) {
      case 1:
        this.handleAddItem();
        break;
      case 2:
        this.handleEditItem();
        break;
      case 3:
        this.handleDeleteConfirmation();
        break;
      case 4:
        this.handleCustomerMaintenance();
        break;
      case 5:
          this.handleManagePremium();
          break;
      default:
        this.setState({ selectedAction: '' });
        break;
    }
  };

  handleManagePremium = () => {
    const { selectedItems, searchItems } = this.state;

    logger.debug(searchItems);

    if (selectedItems.length === 0) {
      this.setState({
        actionErrorMsg: 'You have not selected any items.',
        selectedAction: 5,
      });
    } else {
      const firstSelectedItem = searchItems.find((_) => _.vendorItemId === selectedItems[0]);
      const selectedCommodity = firstSelectedItem.commodity;
      const selectedCertification = firstSelectedItem.certification?.name;
      let returnCode = 0;

      const validateConstraints = (item) => {
        const itemInfo = searchItems.find((_) => _.vendorItemId === item);
        if (itemInfo.commodity === selectedCommodity) {
          if (itemInfo.certification?.name.length > 0) {
            if (itemInfo.certification.name === selectedCertification) {
              returnCode = 0;
            } else {
              returnCode = 1;
            }
          } else {
            returnCode = 2;
          }
        } else {
          returnCode = 3;
        }
        return returnCode;
      };

      if (selectedItems.every((_) => validateConstraints(_) === 0)) {
        this.setState({
          showCustomersModal: false,
          showEditItemModal: false,
          showAddItemModal: false,
          showItemTable: false,
          showManagePremium: true,
          selectedAction: 5,
          actionErrorMsg: '',
        });
      } else if (returnCode === 1) {
        this.setState({
          actionErrorMsg: 'You are trying to set up product premiums for items that do not share the same certification. This action is not permitted. Please review your items and try again.',
          selectedAction: 5,
        });
      } else if (returnCode === 2) {
        this.setState({
          actionErrorMsg: 'Some of the items you selected DO NOT have certification. Certification is required to setup premium. Please review your items and try again',
          selectedAction: 5,
        });
      } else if (returnCode === 3) {
        this.setState({
          actionErrorMsg: 'You are trying to set up product premiums for items that do not share the same commodity. This action is not permitted. Please review your items and try again.',
          selectedAction: 5,
        });
      }
    }
  };

  handleCustomerMaintenance = () => {
    const { selectedItems } = this.state;
    if (selectedItems.length === 0) {
      this.setState({
        actionErrorMsg: 'You have not selected any items.',
        selectedAction: 4,
      });
    } else {
      this.setState({
        showCustomersModal: true,
        showEditItemModal: false,
        showAddItemModal: false,
        showItemTable: false,
        showManagePremium: false,
        selectedAction: 4,
        actionErrorMsg: '',
      });
    }
  };

  handleCustomerMaintenanceFromItemDetails = (selectedItem) => {
    const selectedItems = [];
    selectedItems.push(selectedItem.vendorItemId);
    this.setState({
      selectedItems,
      showCustomersModal: true,
      showEditItemModal: false,
      showAddItemModal: false,
      showItemTable: false,
      showManagePremium: false,
      selectedAction: 4,
      actionErrorMsg: '',
    });
  };

  handleAddItem = () => {
    this.setState({
      showCustomersModal: false,
      showEditItemModal: false,
      showAddItemModal: true,
      showItemTable: false,
      showManagePremium: false,
      selectedAction: 1,
      actionErrorMsg: '',
    });
  };

  handleEditItem = () => {
    const { selectedItems } = this.state;
    if (selectedItems.length === 0) {
      this.setState({
        actionErrorMsg: 'You have not selected any items to edit.',
        selectedAction: 2,
      });
    } else {
      this.setState({
        showEditItemModal: true,
        showItemTable: false,
        showAddItemModal: false,
        showManagePremium: false,
        selectedAction: 2,
        actionErrorMsg: '',
      });
    }
  };

  // GDPS-1483 Delete one or more item(s)
  handleDeleteConfirmation = () => {
    const { selectedItems } = this.state;
    if (selectedItems.length === 0) {
      this.setState({
        actionErrorMsg: 'You have not selected any items to delete.',
        selectedAction: 3,
      });
    } else {
      this.setState({
        showDeleteConfirmation: true,
        selectedAction: 3,
      });
    }
  };

  handleDeleteItems = async (e) => {
    e.preventDefault();
    const { selectedItems, selectedVendor } = { ...this.state };
    const deleteReqs = selectedItems.map((vendorItem) => {
      return new Promise((resolve) => {
        deleteVendorItem(this.state.selectedVendor, vendorItem)
          .then(() => {
            logger.info(`Deleted VendorItem: ${vendorItem}`);
            resolve(true);
          })
          .catch((err) => {
            logger.error(`Unable to delete VendorItem: ${vendorItem}`, err);
            resolve(false);
          });
      });
    });

    Promise.all(deleteReqs).then(() => {
      const event = { target: { value: selectedVendor } };

      this.setState(
        {
          selectedAction: 0,
          showDeleteConfirmation: false,
        },
        () => {
          this.handleVendorChange(event);
        },
      );
    });
  };

  handleEditFromItemDetails = (selectedItem) => {
    const selectedItems = [];
    selectedItems.push(selectedItem.vendorItemId);
    this.setState({
      selectedItems,
      showEditItemModal: true,
      showItemTable: false,
      showAddItemModal: false,
      showManagePremium: false,
      selectedAction: 2,
      actionErrorMsg: '',
    });
  };

  handleSearchChange = (e) => {
    const { items } = { ...this.state };
    const searchCriteria = e.target.value;
    if (searchCriteria.length > 2) {
      const searchItems = items.filter(
        (item) =>
          (item.itemId && item.itemId.toString().includes(searchCriteria)) ||
          (item.description !== null &&
            item.description
              .toLowerCase()
              .includes(searchCriteria.toLowerCase()))
      );
      this.setState({ searchItems });
    } else {
      this.setState({ searchItems: items });
    }
  };

  handleSelectAllCheckBoxClick = () => {
    const { selectAllChecked, searchItems } = this.state;
    if (selectAllChecked) {
      this.setState({
        selectedItems: [],
        selectAllChecked: false,
        selectedAction: '',
      });
    } else {
      const selectedItems = searchItems.map((item) => item.vendorItemId);
      this.setState({
        selectAllChecked: true,
        selectedItems,
        actionErrorMsg: '',
        selectedAction: '',
      });
    }
  };

  handleCheckBoxClick = (e) => {
    const currentItem = e.target.value.toString();
    let { selectedItems } = this.state;

    if (selectedItems.includes(currentItem)) {
      // remove from the array
      selectedItems = selectedItems.filter((item) => item !== currentItem);
    } else {
      selectedItems.push(currentItem);
    }

    this.setState({
      selectedItems,
      selectAllChecked: false,
      actionErrorMsg: '',
      selectedAction: '',
    });
  };

  showItemData = (vendorItemId) => {
    const { items } = this.state;
    const selectedItems = items.filter(
      (item) => item.vendorItemId === vendorItemId
    );
    this.setState({ showItemDetails: true, selectedItem: selectedItems[0] });
  };

  closeItemDetailsModal = () => {
    this.setState({
      showItemDetails: false,
      selectedItem: {},
    });
  };

  cancelDeleteConfirmationModal = () => {
    this.setState(
      {
        showDeleteConfirmation: false,
      },
      this.handleActionChange({
        target: {
          value: 0,
        },
      })
    );
  };

  closeModal = () => {
    this.setState({
      showAddItemModal: false,
      showEditItemModal: false,
      showCustomersModal: false,
      showUploadModal: false,
      selectedAction: '',
      selectedItems: [],
      showItemTable: false,
      selectAllChecked: false,
      showItemDetails: false,
      showManagePremium: false,
      selectedItem: {},
    });

    if (this.state.selectedVendor !== null) {
      const e = {
        target: {
          value: this.state.selectedVendor,
        },
      };

      this.handleVendorChange(e);
    }
  };

  handleSort = (column) => {
    const { sortBy, sortDesc } = this.state;
    const order = sortBy === column ? !sortDesc : true;
    let searchItems;
    if (column === 'id') {
      searchItems = this.handleSortForItemId(order);
    } else if (column === 'description') {
      searchItems = this.handleSortForItemDescription(order);
    } else {
      searchItems = this.handleSortForItemDefaultVendor(order);
    }
    if (sortBy === column) {
      // change sort order
      this.setState({ sortDesc: order, searchItems });
    } else {
      this.setState({ sortBy: column, sortDesc: true, searchItems });
    }
  };

  handleSortForItemId = (order) => {
    const { searchItems } = this.state;

    return order
      ? searchItems.sort(
          (a, b) => parseInt(a.itemId, 10) - parseInt(b.itemId, 10)
        )
      : searchItems.sort(
          (a, b) => parseInt(b.itemId, 10) - parseInt(a.itemId, 10)
        );
  };

  handleSortForItemDescription = (order) => {
    const { searchItems } = this.state;

    return order
      ? searchItems.sort((a, b) => (a.description > b.description ? 1 : -1))
      : searchItems.sort((a, b) => (a.description < b.description ? 1 : -1));
  };

  handleSortForItemDefaultVendor = (order) => {
    const { searchItems } = this.state;

    return order
      ? searchItems.sort((a, b) => a.code > b.code)
      : searchItems.sort((a, b) => a.code < b.code);
  };

  buildCsvData = () => {
    const data = [];

    this.state.searchItems.forEach((item) => {
      data.push({
        Item_Number: parseInt(item.itemId, 10),
        Vendor_Code: this.state.selectedVendor,
        Description: item.description,
        Ti: item.ti,
        Hi: item.hi,
        Pack: item.pack,
        Cost: item.cost,
        Delivered_Cost: item.deliveredCost,
        Unit_Type: item.unitType,
        Country_Of_Origin: item.countryOfOrigin,
        GTIN: item.gtin,
        UPC: item.upc,
        PLU: item.plu,
        Location: item.location,
        Cooler: item.cooler,
        Vendor_Item_Id: item.vendorItemId,
      });
    });

    return data;
  };

  clearSearch = () => {
    const { items } = this.state;
    this.setState({ searchItems: items });
  };

  showUploadModal = () => this.setState({ showUploadModal: true });

  render() {
    const {
      selectedVendor,
      isLoadingVendors,
      showItemTable,
      searchItems,
      showAddItemModal,
      showEditItemModal,
      showCustomersModal,
      showUploadModal,
      selectedItems,
      vendors,
      showItemDetails,
      selectedItem,
      selectAllChecked,
      isLoadingItemsForVendor,
      actionErrorMsg,
      actions,
      selectedAction,
      sortBy,
      sortDesc,
      categories,
      categoryDetails,
      items,
      showDeleteConfirmation,
      currentUser,
      vendorDetails,
      vendorItemCustomers,
      isLoadingCustomers,
      showManagePremium
    } = this.state;

    const vendorCode = decodeURIComponent(selectedVendor).trim();

    if (isLoadingVendors) {
      return (
        <div className="flex-container-row">
          <Pulse text="Loading Vendor Data..." />
        </div>
      );
    }

    const actionBarClassName = showItemTable
      ? 'flex-container-row actions-bar show'
      : 'flex-container-row actions-bar';
    const tableContainerClassName = showItemTable
      ? 'flex-container-row item-table-container show'
      : 'flex-container-row item-table-container';
    const fileName =
      selectedVendor === null ? '' : `${selectedVendor}-items.csv`;

    const summaryCounts =
      searchItems.length === items.length
        ? `${items.length} Total Items for ${vendors[selectedVendor]}`
        : `Search Returned ${searchItems.length} of ${items.length} Total Items`;

    const vendorDropDownDisabled = !!(
      showAddItemModal ||
      showEditItemModal ||
      showCustomersModal
    );

    const itemsToBeEdited = searchItems.filter(
      (item) =>
        item.vendorItemId !== undefined &&
        selectedItems.includes(item.vendorItemId.toString())
    );

    const vendorItemCustomersList = (id) => vendorItemCustomers !== undefined && vendorItemCustomers.length > 0
      ? vendorItemCustomers.filter(item => item.vendorItemId === id).map(item => item.customerCode).sort().join(", ")
      : (isLoadingCustomers ? <div className="customer-code-text skeleton">Loading...</div> : null)


    const listItems = searchItems.map((item, i) => {
      if (item.vendorItemId !== undefined) {
        const checkbox = {};
        checkbox[item.itemId] = '';
        const itemRowClassName =
          showItemDetails && selectedItem.vendorItemId === item.vendorItemId
            ? 'item-row selected'
            : 'item-row';
        const { vendorItemId } = item;
        return (
          <tr key={vendorItemId} className={itemRowClassName}>
            <td>
              <div className="checkbox-container">
                <label className="body-short-form" htmlFor={item.vendorItemId}>
                  <input
                    data-testid={`checkbox-${item.vendorItemId}`}
                    type="checkbox"
                    id={item.vendorItemId}
                    value={item.vendorItemId}
                    checked={
                      selectAllChecked ||
                      selectedItems.includes(item.vendorItemId.toString())
                    }
                    onChange={this.handleCheckBoxClick}
                  />
                  <span />
                </label>
              </div>
            </td>
            <td onClick={() => this.showItemData(item.vendorItemId)}>
              <span data-testid={`itemid-${i}`} className="body-short-form">
                {item.itemId}
              </span>
            </td>
            <td onClick={() => this.showItemData(item.vendorItemId)} style={{"paddingTop": "5px"}}>
              <div
                data-testid={`description-${i}`}
                className="body-short-form description"
              >
                <div>{item.description}
                { (appConfig.PREMIUM_FEATURE_ACTIVE === "true" && item.premium && item.premium.value)
                  ? <span className="burden-icon">P</span>
                  : null
                }
                </div>
              </div>
             
            </td>
            <td onClick={() => this.showItemData(item.vendorItemId)}>
              <span className="body-short-form">
                {item.cost > 0
                  ? currencyFormatter.format(item.cost)
                  : item.cost}
              </span>
            </td>
            <td onClick={() => this.showItemData(item.vendorItemId)}>
              <span className="body-short-form">
                {item.deliveredCost > 0
                  ? currencyFormatter.format(item.deliveredCost)
                  : item.deliveredCost}
              </span>
            </td>
            <td onClick={() => this.showItemData(item.vendorItemId)}>
              <span className="body-short-form">{item.location}</span>
            </td>
            <td onClick={() => this.showItemData(item.vendorItemId)}>
              <span className="body-short-form">{item.isBurdenItem ? '' : item.countryOfOrigin}</span>
            </td>
            <td onClick={() => this.showItemData(item.vendorItemId)}>
              <span className="body-short-form">{item.cooler}</span>
            </td>
            <td className="customer-code-cell" onClick={() => this.showItemData(item.vendorItemId)}>
                  { vendorItemCustomersList(item.vendorItemId) }
            </td>
          </tr>
        );
      }
    });

    const currentVendorCategory = vendorDetails.filter(vendor => vendor.code === vendorCode).map(selectedVendorDetails => {
      if (selectedVendorDetails.meat)
        return 'meat'
      else if (selectedVendorDetails.produce)
        return 'produce'
      else if (selectedVendorDetails.seafood)
        return 'seafood'
      else
        return ''
    })
    
    return (
      <div>
        {showAddItemModal ? (
          <div className="flex-container-row top-level">
            <div
              style={{ paddingLeft: '20px', paddingTop: '10px' }}
              className="headline-small fixed-divider"
            >
              Add New Items For:
            </div>
          </div>
        ) : null}

        {showEditItemModal ? (
          <div className="flex-container-row top-level">
            <div
              style={{ paddingLeft: '20px', paddingTop: '10px' }}
              className="headline-small fixed-divider"
            >
              Editing Items For:
            </div>
          </div>
        ) : null}

        {showCustomersModal ? (
          <div className="flex-container-row top-level">
            <div
              style={{ paddingLeft: '20px', paddingTop: '10px' }}
              className="headline-small fixed-divider"
            >
              Customer Maintenance For:
            </div>
          </div>
        ) : null}

        {showManagePremium ? (
          <div className="flex-container-row top-level">
            <div
              style={{ paddingLeft: '20px', paddingTop: '10px' }}
              className="headline-small fixed-divider"
            >
              Manage Premium For:
            </div>
          </div>
        ) : null}

        <div className="flex-container-row vendor-container">
          <div className="flex-container-column">
            <DropDown
              id="vendor-dropdown"
              isDisabled={vendorDropDownDisabled}
              options={vendors}
              data-testid="select-a-vendor"
              placeHolderText="Select a Vendor"
              placeHolderDisabled
              handleChange={this.handleVendorChange}
            />
          </div>

          {this.state.showEditItemModal ||
          this.state.showAddItemModal ||
          this.state.showManagePremium ||
          this.state.showCustomersModal ? null : (
            <div className="flex-container-column button-padding">
              <PrimaryButton
                onClick={this.showUploadModal}
                name={'Upload Cost Sheet'}
              />
            </div>
          )}

          {this.state.showEditItemModal ||
          this.state.showAddItemModal ||
          this.state.showManagePremium ||
          this.state.showCustomersModal ? (
            <div className="flex-container-column button-padding">
              <PrimaryButton
                onClick={this.closeModal}
                name="Return to Dashboard"
              />
            </div>
          ) : null}
        </div>

        {isLoadingItemsForVendor ? (
          <div className="flex-container-row">
            <Pulse text="Loading Data..." />
          </div>
        ) : null}

        {!isLoadingItemsForVendor ? (
          <div data-testid="action-bar" className={actionBarClassName}>
            <div className="flex-container-column">
              <div className="flex-container-row">
                <DropDown
                  errorMsg={actionErrorMsg}
                  value={selectedAction.toString()}
                  id="actions"
                  options={actions}
                  placeHolderText="Actions..."
                  handleChange={this.handleActionChange}
                />
                <SearchInput
                  id="item-search"
                  clearSearch={this.clearSearch}
                  handleChange={this.handleSearchChange}
                  placeHolderText="Search By Item Number or Description"
                />
              </div>
            </div>

            {this.state.searchItems.length !== 0 ? (
              <div className="flex-container-column upload-cost-sheet">
                <div className="flex-container-row">
                  <CSVLink
                    className="primary-button"
                    filename={fileName}
                    data={this.buildCsvData()}
                  >
                    Download Cost Sheet
                  </CSVLink>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {!isLoadingItemsForVendor ? (
          <div data-testid="item-table" className={tableContainerClassName}>
            <div className="flex-container-row item-count">{summaryCounts}</div>
            <table
              className="item-table"
              cellPadding="0"
              cellSpacing="0"
              width="100%"
            >
              <colgroup>
                <col span="1" style={{ width: '5%' }} />
                <col span="1" style={{ width: '10%' }} />
                <col span="1" style={{ width: '30%' }} />
                <col span="1" style={{ width: '10%' }} />
                <col span="1" style={{ width: '10%' }} />
              </colgroup>

              <tbody>
                <tr className="item-table-header">
                  <td>
                    <div className="checkbox-container" key={1}>
                      <label className="body-short-form" htmlFor="1">
                        <input
                          type="checkbox"
                          id={1}
                          value={1}
                          checked={selectAllChecked}
                          onChange={this.handleSelectAllCheckBoxClick}
                        />
                        <span />
                      </label>
                    </div>
                  </td>
                  <td
                    data-testid="sort-item-number"
                    className="sort-column"
                    onClick={() => this.handleSort('id')}
                  >
                    <span>Item Number</span>
                    {sortBy === 'id' ? (
                      <img
                        className="sort-order-image"
                        src={sortDesc ? downarrow : uparrow}
                        alt={
                          sortDesc
                            ? 'sort by item id desc'
                            : 'sort by item id asc'
                        }
                        height="15"
                        width="15"
                      />
                    ) : null}
                  </td>
                  <td
                    data-testid="sort-description"
                    className="sort-column"
                    onClick={() => this.handleSort('description')}
                  >
                    <span>Description</span>
                    {sortBy === 'description' ? (
                      <img
                        className="sort-order-image"
                        src={sortDesc ? downarrow : uparrow}
                        alt={
                          sortDesc
                            ? 'sort by item description desc'
                            : 'sort by item description asc'
                        }
                        height="15"
                        width="15"
                      />
                    ) : null}
                  </td>
                  <td>Vendor Cost</td>
                  <td>Del Cost</td>
                  <td>Location</td>
                  <td>COO</td>
                  <td>Cooler</td>
                  <td>Customers</td>
                </tr>
                {listItems}
              </tbody>
            </table>
          </div>
        ) : null}

        {showCustomersModal ? (
          <MaintainCustomers
            data={{
              customers: this.state.customers,
              customerDetails: this.state.customerDetails,
              vendors: vendors
            }}
            selectedItems={itemsToBeEdited}
            closeModal={this.closeModal}
            vendorCode={vendorCode}
            vendorName={this.state.vendors[vendorCode]}
            currentUser={currentUser}
          />
        ) : null}

        {showItemDetails ? (
          <ItemDetailsModal
            customerDetails={this.state.customerDetails}
            showItemDetails={this.state.showItemDetails}
            editCustomers={this.handleCustomerMaintenanceFromItemDetails}
            editItem={this.handleEditFromItemDetails}
            closeModal={this.closeItemDetailsModal}
            selectedItem={this.state.selectedItem}
          />
        ) : null}

        {showAddItemModal ? (
          <AddItemModal
            vendorCode={vendorCode}
            closeModal={this.closeModal}
            categories={categories}
            categoryDetails={categoryDetails}
            currentUser={currentUser}
          />
        ) : null}

        {showUploadModal ? (
          <UploadCSVModal
            closeModal={this.closeModal}
            locations={this.state.locations}
            countryOfOrigins={this.state.countryOfOrigins}
            currentUser={currentUser}
          />
        ) : null}

        {this.state.showEditItemModal && itemsToBeEdited.length > 0 ? (
          <EditItemModal
            selectedItems={itemsToBeEdited}
            closeModal={this.closeModal}
            locations={this.state.locations}
            countryOfOrigins={this.state.countryOfOrigins}
            currentUser={currentUser}
            currentVendorCategory={currentVendorCategory}
          />
        ) : null}

        {showDeleteConfirmation ? (
          <DeleteConfirmationModal
            selectedItems={itemsToBeEdited}
            closeModal={this.cancelDeleteConfirmationModal}
            deleteItems={this.handleDeleteItems}
          />
        ) : null}

        { showManagePremium && itemsToBeEdited.length > 0 
          ? <AddPremium selectedItems={itemsToBeEdited} closeModal={this.closeModal} currentVendorCategory={currentVendorCategory} />
          :null
        }
      </div>
    );
  }
}

export default VendorItemRelationshipMaintenance;
